import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueFire, VueFireAuth } from 'vuefire'
import App from './App.vue'
import { router } from './router'
import { firebaseApp } from './lib/firebase'
import { installNativeWindowStateBridge } from './lib/picture-in-picture'

import './style.css'

// Installed at boot, not when the exam runner mounts: a WebView host can
// report a floating window while the SPA is still starting, and a report that
// arrives before the function exists is lost — which would leave the exam
// answerable under a window the host had already told us about.
installNativeWindowStateBridge()

function showBanner(): void {
  let banner = document.getElementById('unhandled-error-banner')
  if (!banner) {
    banner = document.createElement('div')
    banner.id = 'unhandled-error-banner'
    banner.setAttribute('role', 'alert')
    banner.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:2147483647;padding:16px;background:#991b1b;color:white;text-align:center;'
    const message = document.createElement('span')
    message.textContent = 'Something went wrong. Please try again. If the problem persists, reload the page.'
    const dismiss = document.createElement('button')
    dismiss.type = 'button'
    dismiss.textContent = 'Dismiss'
    dismiss.style.cssText = 'margin-left:16px;text-decoration:underline;'
    dismiss.addEventListener('click', () => banner?.remove())
    banner.append(message, dismiss)
    document.body.appendChild(banner)
  }
}

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason)
  showBanner()
})

const app = createApp(App)
app.config.errorHandler = (error) => {
  console.error('Unhandled Vue error:', error)
  showBanner()
}

app.use(createPinia())
app.use(router)
app.use(VueFire, {
  firebaseApp,
  modules: [VueFireAuth()],
})

app.mount('#app')
